var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIMacPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iMac-Pink"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.8203 8H6.82031C6.28988 8 5.78117 8.21071 5.4061 8.58579C5.03103 8.96086 4.82031 9.46957 4.82031 10V46C4.82031 46.5304 5.03103 47.0391 5.4061 47.4142C5.78117 47.7893 6.28988 48 6.82031 48H50.8203C51.3507 48 51.8595 47.7893 52.2345 47.4142C52.6096 47.0391 52.8203 46.5304 52.8203 46V10C52.8203 9.46957 52.6096 8.96086 52.2345 8.58579C51.8595 8.21071 51.3507 8 50.8203 8Z",
    fill: "#009DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.8203 40V10C52.8203 9.46957 52.6096 8.96086 52.2345 8.58579C51.8595 8.21071 51.3507 8 50.8203 8H6.82031C6.28988 8 5.78117 8.21071 5.4061 8.58579C5.03103 8.96086 4.82031 9.46957 4.82031 10V40H52.8203Z",
    fill: "#8246AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.8203 48H20.8203V52H36.8203V48Z",
    fill: "#009DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.8203 40H20.8203V48H36.8203V40Z",
    fill: "#0061C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.82031 12H48.8203V36H8.82031V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.8203 52H14.8203V56H20.8203V52ZM42.8203 52H36.8203V56H42.8203V52Z",
    fill: "#8246AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.8203 52H20.8203V56H36.8203V52Z",
    fill: "#00267A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 58684"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 143",
    cx: 28.9801,
    cy: 30.6471,
    r: 1.70182,
    fill: "#00267A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4531",
    d: "M27.0483 17.4175C26.9684 16.3058 27.8658 15.3599 28.9804 15.3599C30.095 15.3599 30.9924 16.3058 30.9125 17.4175L30.2236 27.0028C30.1768 27.6548 29.6341 28.1599 28.9804 28.1599C28.3267 28.1599 27.784 27.6548 27.7371 27.0028L27.0483 17.4175Z",
    fill: "#00267A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMacPink);
export default __webpack_public_path__ + "static/media/iMac-Pink.d03826d0ae943371450b7dd37e477774.svg";
export { ForwardRef as ReactComponent };